import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "simplePage"
};
import { onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useProducts } from '@/composables/useProducts';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import CategoryButton from './elements/CategoryButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CalculatorsPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer, getEmployer } = useCustomer();
        const { getProducts } = useProducts();
        onMounted(() => {
            getCustomer(() => {
                getEmployer(state.customer.employerID);
                getProducts();
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Calculators" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).marketplace.length && _unref(state).employer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).products.length && _unref(state).employer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).calculators, (product) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass('hubItemWrapper'),
                                            key: product.id
                                        }, [
                                            _createVNode(CategoryButton, {
                                                image: product.thumbnail,
                                                title: product.name,
                                                href: product.websiteUrl,
                                                barColor: "#e9e7f2"
                                            }, null, 8, ["image", "title", "href"])
                                        ]));
                                    }), 128))
                                ]),
                                _cache[0] || (_cache[0] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
